import { defineAsyncComponent } from 'vue'
import { tabOutlineList } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { QueryConfig } from 'src/composables/use-query'
import type {
  FeatureConfig,
  MainFeatureTwin,
  FeatureQueryTwin,
  FeatureParameterConfigs
} from 'src/models'
import type { DashboardTileActionType } from 'src/components/features/DashboardFeature'
import { type DashboardTileAction } from 'src/components/features/DashboardFeature'
import type { ParameterDisplayStyle } from 'src/models/FeatureParameter'

/** Action types supported by ListFeature */
export type ListActionType =
  | DashboardTileActionType.SetParameter
  | DashboardTileActionType.LoadFeature
  | DashboardTileActionType.ScrollTo

/** Action display style */
export type ActionDisplayStyle = 'buttons' | 'contextMenu'

/** Action configuration for ListFeature - extends DashboardTileAction */
export interface ListAction extends DashboardTileAction {
  actionType: ListActionType
  actionGroup?: string
  displayStyle?: ActionDisplayStyle
  label?: string
  icon?: string
  color?: string
}

/** Action button style configuration */
export interface ActionButtonStyle {
  cssClass?: string
  cssStyle?: string
  style?: 'square' | 'round' | 'rounded'
  outline?: boolean
  flat?: boolean
}

export interface ListFeatureTwin extends MainFeatureTwin, QueryConfig {
  /** @deprecated */
  useQueryLocations?: boolean
  filter?: boolean
  allowExportExcel?: boolean
  viewerIsolateItems?: boolean
  parameters?: FeatureParameterConfigs
  /** HTML content with JEXL evaluation */
  content?: string
  /** Disable selection functionality when clicking on list items */
  disableSelect?: boolean
  /** Actions that can be performed on list items */
  actions?: { [key: string]: ListAction }
  /** Default display style for actions */
  actionsDisplayStyle?: ActionDisplayStyle
  /** Button style for actions when displayed as buttons */
  actionsButtonStyle?: ActionButtonStyle
  /** Automatically sync selected twins to the store when selection changes */
  syncSelection?: boolean
  /** Always fetch selected twins from API even if already in the store */
  syncSelectionOverwrite?: boolean
}

/** dtmi:com:arcadis:app:ListQuery;2 */
export interface ListQueryTwin extends FeatureQueryTwin, QueryConfig {
  /** Controls how this query appears as a parameter option in the toolbar */
  displayStyle?: ParameterDisplayStyle
  allowCreate?: boolean
  createName?: string
  createModelId?: string
  createParentTwinId?: string
  createRelationshipName?: string
  viewerLoadState?: boolean
  viewerIsolateItems?: boolean
  viewerIsolateChildItems?: boolean
  viewerShowChildItems?: boolean
  viewerShowParentItems?: boolean
  viewerColorItems?: boolean
  viewerColorChildItems?: boolean
  viewerColorParentItems?: boolean
  viewerLabelItems?: boolean
  viewerHideMarkers?: boolean
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./ListFeatureMain.vue')),
    splitter: 450,
    icon: tabOutlineList,
    label: 'List'
  }
}

export default featureConfig
